import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";

const getComplaintForProvince = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaint/ComplaintForProvince",
    params
  );
};
const getComplaintForBangkok = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaintbangkok/ComplaintForBangkok",
    params
  );
};
const GetComplaintForBangkokHistorySearch = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaintbangkok/ComplaintForBangkokHistorySearch",
    params
  );
};

const getComplaintBangkokSummary = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaintbangkok/ComplaintSummary",
    params
  );
};
const getComplaintBangkokChart = (params) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Complaintbangkok/ComplaintChart",
    params
  );
};

export { 
  getComplaintForProvince,
  getComplaintForBangkok,
  GetComplaintForBangkokHistorySearch,
  getComplaintBangkokSummary,
  getComplaintBangkokChart,
};